import { api } from "utils/api";

export const getPackages = ({ locale }: { locale: string }) =>
  api.get("/package", undefined, {
    headers: {
      "Accept-Language": locale,
    },
  });
